//CORE
import React from "react";
import Audit from '../components/Audit.js';
import ListOfValues from '../components/DataManagement/DataManagementDetailListOfValues.js';
import Locales from '../components/DataManagement/DataManagementDetailLocales.js';

//CUSTOM
import AppMenuItems from '../components/AppMenu/AppMenuItems.js';
import AppMenuItemRoutes from '../components/AppMenu/AppMenuItemRoutes.js';
import AppMenuItemRouteTabs from '../components/AppMenu/AppMenuItemRouteTabs.js';
import AccountDetailEvents from '../components/Account/AccountDetailEvents.js';
import AccountDetailTasks from '../components/Account/AccountDetailTasks.js';
import AccountDetailNotes from '../components/Account/AccountDetailNotes.js';
import EventDetailTasks from '../components/Event/EventDetailTasks.js';
import ReportDetailAccountHoursPeriod from '../components/Report/ReportDetailAccountHoursPeriod.js';
import ReportDetailTaskEmployeeHoursPeriod from '../components/Report/ReportDetailTaskEmployeeHoursPeriod.js';
import ReportDetailWorkdayHours from '../components/Report/ReportDetailWorkdayHours.js';
import TaskDetailEmployees from '../components/Task/TaskDetailEmployees';
import TaskDetailNotes from '../components/Task/TaskDetailNotes';
import TaskDetailNotesHistory from '../components/Task/TaskDetailNotesHistory';
import UserDetailTasks from '../components/User/UserDetailTasks.js';
import UserDetailTravelTime from '../components/User/UserDetailTravelTime.js';
import UserDetailReports from '../components/User/UserDetailReports.js';
import UserDetailWorkedHours from '../components/User/UserDetailWorkedHours.js';
import UserDetailWorkday from '../components/User/UserDetailWorkday.js';

const EntityComponentMap={
  accounts_accounts:React.lazy(()=>import('../components/Account/Accounts.js')),
  accounts_account:React.lazy(()=>import('../components/Account/AccountDetail.js')),
  accounts_account_new:React.lazy(()=>import('../components/Account/AccountNew.js')),
  users_users:React.lazy(()=>import('../components/User/Users.js')),
  users_user:React.lazy(()=>import('../components/User/UserDetail.js')),
  users_user_new:React.lazy(()=>import('../components/User/UserDetailNew.js')),
  tasks_tasks:React.lazy(()=>import('../components/Task/Tasks.js')),
  tasks_task:React.lazy(()=>import('../components/Task/TaskDetail.js')),
  notes_notes:React.lazy(()=>import('../components/Note/Notes.js')),
  reports_reports:React.lazy(()=>import('../components/Report/ReportDetail.js')),
  schedule_schedule_wrapper:React.lazy(()=>import('../components/Schedule/ScheduleWrapper.js')),
  schedule_schedule:React.lazy(()=>import('../components/Schedule/Schedule.js')),
  my_workday_my_workday:React.lazy(()=>import('../components/Workday/MyWorkday.js')),
  events_events:React.lazy(()=>import('../components/Event/Events.js')),
  events_event:React.lazy(()=>import('../components/Event/EventDetail.js')),
  events_event_new:React.lazy(()=>import('../components/Event/EventDetailNew.js')),
  notifications_notifications:React.lazy(()=>import('../components/Notification/Notifications.js')),
  notifications_notification:React.lazy(()=>import('../components/Notification/Notification.js')),
  my_notifications_my_notifications:React.lazy(()=>import('../components/Notification/Notifications.js')),
  my_notifications_my_notification:React.lazy(()=>import('../components/Notification/Notification.js')),
  server_management_server_management:React.lazy(()=>import('../components/ServerManagement/ServerManagementDetail.js')),
  data_management_data_management:React.lazy(()=>import('../components/DataManagement/DataManagementDetail.js')),
  app_roles_app_roles:React.lazy(()=>import('../components/AppRole/AppRoles.js')),
  holidays_holidays:React.lazy(()=>import('../components/Holidays/Holidays.js')),
  app_menus_app_menus:React.lazy(()=>import('../components/AppMenu/AppMenus.js')),
  app_menus_app_menu:React.lazy(()=>import('../components/AppMenu/AppMenuDetail.js')),
  app_menus_app_menu_item:React.lazy(()=>import('../components/AppMenu/AppMenuItemDetail.js')),
  app_menus_app_menu_item_route:React.lazy(()=>import('../components/AppMenu/AppMenuItemRouteDetail.js')),
};

export const getEntityComponent=(entity)=>EntityComponentMap[entity]||null;

const PageTabComponentMap={
    account:{
      events:AccountDetailEvents,
      tasks:AccountDetailTasks,
      notes:AccountDetailNotes,
      audit:Audit,
    },
    event:{
      tasks:EventDetailTasks,
      audit:Audit,
    },
    reports:{
      account_hours_period:ReportDetailAccountHoursPeriod,
      task_employee_hours_period:ReportDetailTaskEmployeeHoursPeriod,
      workday_hours:ReportDetailWorkdayHours,
    },
    task:{
      hours:TaskDetailEmployees,
      notes:TaskDetailNotes,
      history:TaskDetailNotesHistory,
      audit:Audit,
    },
    user:{
      tasks:UserDetailTasks,
      travel_time:UserDetailTravelTime,
      reports:UserDetailReports,
      worked_hours:UserDetailWorkedHours,
      workday:UserDetailWorkday,
      audit:Audit,
    },
    data_management:{
      list_of_values:ListOfValues,
      locales:Locales,
    },
    app_menu:{
      items:AppMenuItems,
      audit:Audit,
    },
    app_menu_item:{
      routes:AppMenuItemRoutes,
      audit:Audit,
    },
    app_menu_item_route:{
      route_tabs:AppMenuItemRouteTabs,
      audit:Audit,
    },
};

export const getPageTabComponent=(entityKey,tabKey)=>{
  const entityMap=PageTabComponentMap[entityKey];
  if(!entityMap) return null;
  return entityMap[tabKey]||null;
};